import { ToastService } from "../../../../services/toast.ts";

export class OrgGeneralTab extends HTMLElement {
  private _org: any = null;
  private _orgId: string = '';

  set org(val: any) {
    this._org = val;
    this.render();
  }

  set orgId(val: string) {
    this._orgId = val;
    this.render();
  }

  connectedCallback() {
    this.render();
  }

  private render() {
    if (!this._org && !this._orgId) {
      this.innerHTML = `<div style="padding: 20px; color: var(--text-dim); font-family: var(--font-mono);">LOADING_GENERAL_DATA...</div>`;
      return;
    }

    this.innerHTML = `
      <div style="display: flex; flex-direction: column; gap: 40px; max-width: 800px;">
        <div class="sketchy-card">
          <div style="position: relative; z-index: 2;">
            <h3 style="margin: 0 0 24px 0; color: var(--text-main); font-family: var(--font-sketch);">Organization Details</h3>
            
            <div style="display: flex; flex-direction: column; gap: 24px;">
              <div>
                <label style="display: block; margin-bottom: 8px; font-size: 0.75rem; color: var(--text-dim); font-family: var(--font-mono);">ORGANIZATION NAME</label>
                <input type="text" id="org-name-input" value="${this._org?.name || ''}" 
                       style="width: 100%; padding: 12px; background: rgba(255,255,255,0.03); border: 1px solid var(--border-sketch); color: white; border-radius: 4px; font-family: var(--font-mono);">
              </div>

              <div>
                <label style="display: block; margin-bottom: 8px; font-size: 0.75rem; color: var(--text-dim); font-family: var(--font-mono);">ORGANIZATION ID</label>
                <div style="display: flex; gap: 8px;">
                  <input type="text" readonly id="org-id-display" value="${this._orgId}" 
                         style="flex: 1; padding: 12px; background: rgba(255,255,255,0.02); border: 1px dashed var(--border-sketch); color: var(--text-dim); border-radius: 4px; font-family: var(--font-mono); font-size: 0.8rem;">
                  <app-button variant="secondary" id="copy-org-id-btn" icon="copy" size="sm">
                  </app-button>
                </div>
                </div>
              </div>

              <div style="margin-top: 16px; display: flex; justify-content: space-between; align-items: center; padding-top: 24px; border-top: 1px solid var(--border-sketch);">
                <div>
                  <div style="color: var(--text-main); font-family: var(--font-sketch); font-size: 1.1rem; margin-bottom: 4px;">Shared Edge Sync</div>
                  <div style="color: var(--text-dim); font-size: 0.85rem; font-family: var(--font-mono);">Publish this organization's configurations to the shared managed gateway network.</div>
                </div>
                
                ${(() => {
                  const planModules = this._org?.plan?.modules || [];
                  const activeModules = this._org?.active_modules || this._org?.modules || [];
                  const hasSharedGateway = planModules.includes('shared_gateway') || 
                                           activeModules.some((m: any) => (typeof m === 'string' ? m : m.id) === 'shared_gateway');
                  
                  if (!hasSharedGateway) {
                    return `<div style="font-size: 0.75rem; color: var(--text-muted); font-family: var(--font-mono); font-style: italic;">Requires Shared Gateway Subscription</div>`;
                  }
                  
                  return `
                    <label style="position: relative; display: inline-block; width: 50px; height: 24px;">
                      <input type="checkbox" id="org-sync-shared-toggle" ${this._org?.sync_to_shared_gateway !== false ? 'checked' : ''} style="opacity: 0; width: 0; height: 0;">
                      <span class="slider" style="position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.1); transition: .4s; border-radius: 24px; border: 1px solid var(--border-sketch);"></span>
                      <span class="slider-thumb" style="position: absolute; height: 16px; width: 16px; left: 4px; bottom: 3px; background-color: var(--text-dim); transition: .4s; border-radius: 50%;"></span>
                    </label>
                    <style>
                      #org-sync-shared-toggle:checked + .slider { background-color: rgba(76, 175, 80, 0.2); border-color: #4CAF50; }
                      #org-sync-shared-toggle:checked + .slider + .slider-thumb { transform: translateX(24px); background-color: #4CAF50; }
                    </style>
                  `;
                })()}
              </div>
            </div>
          </div>
      </div>
    `;

    this.setupListeners();
  }

  private setupListeners() {
    const nameInput = this.querySelector('#org-name-input') as HTMLInputElement;
    if (nameInput) {
      nameInput.addEventListener('input', () => {
        this.dispatchEvent(new CustomEvent('change', { bubbles: true, composed: true }));
      });
    }

    const syncToggle = this.querySelector('#org-sync-shared-toggle') as HTMLInputElement;
    if (syncToggle) {
      syncToggle.addEventListener('change', () => {
        this.dispatchEvent(new CustomEvent('change', { bubbles: true, composed: true }));
      });
    }

    const copyBtn = this.querySelector('#copy-org-id-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(this._orgId);
        ToastService.getInstance().success('ID copied to clipboard');
      });
    }

  }

  public getFormData() {
    const nameInput = this.querySelector('#org-name-input') as HTMLInputElement;
    const syncToggle = this.querySelector('#org-sync-shared-toggle') as HTMLInputElement;
    return {
      name: nameInput?.value,
      sync_to_shared_gateway: syncToggle?.checked
    };
  }
}

if (!customElements.get('org-general-tab')) {
  customElements.define('org-general-tab', OrgGeneralTab);
}
